import { createClientOnlyFn } from '@tanstack/react-start';

export const getQueryParams = createClientOnlyFn(
  () => new URLSearchParams(window.location.search)
);
